(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[31985],{

/***/ 71700:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var Local = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return "".concat(src, "?quality=").concat(quality || 75);
};
/* harmony default export */ __webpack_exports__["Z"] = (Local);


/***/ }),

/***/ 58114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ static_Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/ImageLoader.js
var ImageLoader = __webpack_require__(71700);
// EXTERNAL MODULE: ./static/Footer.module.css
var Footer_module = __webpack_require__(56214);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./static/Footer/CopyRight.js



var CopyRight = function() {
    var copyRight = (0,TranslationContext/* useTranslation */.m)().copyRight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container py-4 lg:py-8 flex justify-between mb-16 lg:mb-0 flex-col items-center lg:flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-medium text-xs text-brand-black",
                children: copyRight
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "B\xf6cekSoft"
            })
        ]
    });
};
/* harmony default export */ var Footer_CopyRight = (CopyRight);

// EXTERNAL MODULE: ./themes/themes.js
var themes = __webpack_require__(89507);
;// CONCATENATED MODULE: ./static/Footer.js












var Footer = function(param) {
    var ssr = param.ssr;
    var ref = (0,TranslationContext/* useTranslation */.m)(), footerPaymentLinkButtonText = ref.footerPaymentLinkButtonText, pay = ref.pay;
    var ref1 = (0,react.useState)(false), Menu = ref1[0], setMenu = ref1[1];
    var ref2 = (0,react.useState)(true), isLoading = ref2[0], setIsLoading = ref2[1];
    (0,react.useEffect)(function() {
        (0,api/* GetFooterMenu */.ys)().then(function(response) {
            if (response.data.error) {
                toast.error(response.data.error);
                setMenu([]);
            } else {
                setMenu(response.data);
                setIsLoading(false);
            }
        }).catch(function(error) {
            toast.error(error.message);
        });
    }, []);
    var FooterLinkGroup = function(param) {
        var val = param.val;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:flex flex-col hidden " + (Footer_module_default()).FooterLinkGroup,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Footer_module_default()).FooterTitle,
                    children: val.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap justify-between gap-y-5",
                    children: val.items.map(function(i, k) {
                        var attr = {};
                        if (i.nofollow == 0) attr["rel"] = "nofollow";
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: i.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                title: i.title
                            }, attr), {
                                children: [
                                    i.name,
                                    " "
                                ]
                            }))
                        }, k);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-brand-gray-7 bg-no-repeat bg-left " + (ssr.RoutingTypeId == "Home" ? "pt-40" : "pt-10") + " " + themes/* default.footerBgLogo */.Z.footerBgLogo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container lg:py-14 pb-8 flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:w-5/12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden lg:block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: themes/* default.logo */.Z.logo,
                                            width: themes/* default.footerLogoWidth */.Z.footerLogoWidth,
                                            height: 50,
                                            loader: ImageLoader/* default */.Z,
                                            alt: "Balayi Villası Kirala" + " Logo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex mt-6 justify-between",
                                        children: [
                                            Menu ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-xs text-brand-gray-9 font-semibold mr-1",
                                                        children: [
                                                            Menu.static.email,
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            Menu.static.adres
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-lg text-brand-gray-9 mt-2 leading-9 ml-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: Menu.static.telefon.replace(Menu.static.telefon.substr(Menu.static.telefon.length - 9), "")
                                                            }),
                                                            Menu.static.telefon.substr(Menu.static.telefon.length - 9)
                                                        ]
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://etbis.eticaret.gov.tr/sitedogrulama/6067570258707468",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    rel: "nofollow",
                                                    className: "lg:hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/icons/etbis.svg",
                                                        width: 79,
                                                        height: 90,
                                                        loader: ImageLoader/* default */.Z,
                                                        alt: "Etbis QR Kod"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-between flex-col mm:flex-row lg:hidden items-center mm:items-start mt-5 mm:mt-0 gap-y-3 mm:gap-y-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-x-3 items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-black font-bold text-13",
                                                        children: "Takipte Kal"
                                                    }),
                                                    Menu ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            Menu.social.instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: Menu.social.instagram,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    title: "Balayi Villası Kirala" + " Instagram",
                                                                    target: "_blank",
                                                                    rel: "nofollow",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "w-9 h-9 relative rounded-full bg-white p-2",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/icons/instagram.svg",
                                                                            alt: "Balayi Villası Kirala" + " Instagram",
                                                                            width: 20,
                                                                            height: 20,
                                                                            loader: ImageLoader/* default */.Z
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            Menu.social.facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: Menu.social.facebook,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    title: "Balayi Villası Kirala" + " Facebook",
                                                                    target: "_blank",
                                                                    rel: "nofollow",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "w-9 h-9 relative rounded-full bg-white p-2",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/icons/facebook.svg",
                                                                            alt: "Balayi Villası Kirala" + " Facebook",
                                                                            width: 20,
                                                                            height: 20,
                                                                            loader: ImageLoader/* default */.Z
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            Menu.social.youtube && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: Menu.social.youtube,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    title: "Balayi Villası Kirala" + " Youtube",
                                                                    target: "_blank",
                                                                    rel: "nofollow",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "w-9 h-9 relative rounded-full bg-white p-2",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/icons/youtube.svg",
                                                                            alt: "Balayi Villası Kirala" + " Youtube",
                                                                            width: 20,
                                                                            height: 20,
                                                                            loader: ImageLoader/* default */.Z
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://www.tursab.org.tr/tr/ddsv",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    rel: "nofollow",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/icons/tursab.svg",
                                                        width: 80,
                                                        height: 42,
                                                        loader: ImageLoader/* default */.Z,
                                                        alt: "T\xfcrsab Logo"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex mt-8 justify-between ml:justify-start sm:justify-center lg:justify-start",
                                        children: Menu ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: Menu.static.Page1.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        title: Menu.static.Page1.title,
                                                        className: "px-2 ml:px-7 py-2 font-bold text-xs ml:text-13 text-white tracking-widest bg-brand-color-primary rounded-sm leading-10 ml:mr-3",
                                                        children: Menu.static.Page1.kisa_baslik
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: Menu.static.Page2.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        title: Menu.static.Page2.title,
                                                        className: "px-2 ml:px-7 py-2 font-bold text-xs ml:text-13 text-black tracking-widest bg-white rounded-sm leading-10",
                                                        children: Menu.static.Page2.kisa_baslik
                                                    })
                                                })
                                            ]
                                        }) : null
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full flex-col text-center mm:text-left mm:gap-x-4 mm:flex-row-reverse justify-end sm:justify-center mt-5 ml:gap-x-12 lg:w-7/12 lg:flex-row lg:mt-0 gap-y-5 mm:gap-y-0",
                                children: Menu && Menu.data.map(function(val, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinkGroup, {
                                        val: val
                                    }, key);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mt-11 justify-center lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-5/12 hidden lg:flex items-center gap-x-7",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://etbis.eticaret.gov.tr/sitedogrulama/6067570258707468",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            rel: "nofollow",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/icons/etbis.svg",
                                                width: 62,
                                                height: 71,
                                                loader: ImageLoader/* default */.Z,
                                                alt: "Etbis QR Kod"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://www.tursab.org.tr/tr/ddsv",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            rel: "nofollow",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/icons/tursab.svg",
                                                width: 190,
                                                height: 108,
                                                loader: ImageLoader/* default */.Z,
                                                alt: "T\xfcrsab Logo"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full ml:w-auto lg:w-7/12 flex items-center justify-between flex-col-reverse lg:flex-row gap-x-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center lg:mt-0 relative h-14 w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/images/payments.svg",
                                            objectFit: "contain",
                                            layout: "fill",
                                            alt: "",
                                            loader: ImageLoader/* default */.Z
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center mt-9 lg:mt-0 relative h-10 flex-shrink w-48 lg:ml-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/images/visamaster.png",
                                            objectFit: "contain",
                                            layout: "fill",
                                            alt: "",
                                            loader: ImageLoader/* default */.Z
                                        })
                                    }),
                                     false && /*#__PURE__*/ 0
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_CopyRight, {})
        ]
    });
};
/* harmony default export */ var static_Footer = (Footer);


/***/ }),

/***/ 56214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FooterLinkGroup":"Footer_FooterLinkGroup__r7vtx","FooterTitle":"Footer_FooterTitle__bqatX"};

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

}]);